import { useTranslation } from "@opendash/i18n";
import { useNavigate } from "@opendash/router";
import { Button, Card, Flex } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { useProject } from "..";
import { Project } from "../../../../js/parsegenerated";
import { ProjectTitle } from "./card-items/ProjectTitle";
import { ProjectAssignment } from "./ProjectAssignment";

type Props = {
  hideSubProjects?: boolean;
  parent?: Project;
};

export const ProjectListView = observer((props: Props) => {
  const nav = useNavigate();
  const t = useTranslation();
  const { project, color } = useProject();

  return (
    <Card size="small" style={{ overflow: "hidden" }}>
      <Flex justify="space-between" align="center">
        <div
          style={{
            height: "100%",
            width: "1rem",
            backgroundColor: color,
            position: "absolute",
            left: 0,
          }}
        />
        <Flex gap="1rem" align="center">
          <div /* spacer */ />
          <ProjectTitle parent={props.parent} />
          <ProjectAssignment />
        </Flex>

        <Button onClick={() => nav(`/openservice/project/${project.id}`)}>
          {t("maintenance:project.navigate.single")}
        </Button>
      </Flex>
    </Card>
  );
});
